import React from 'react';
import { useDispatch } from 'react-redux';

import ConsumerLayout from '../consumer-layout/ConsumerLayout';
import Header from './components/header/Header';
import PredictResponse from '../../genie-go/components/predict-response/PredictResponse';
import { uploadFile } from '../../redux/scout/scoutActions';
import {
  generateConsumerGenieGoMessages,
  predictConsumerGenieGoResponse,
  replyConsumerGenieGo,
  resetGenieGoSession,
} from '../../redux/consumer/genie-go/consumerGenieGoActions';
import GenerateMessages from '../../genie-go/components/generate-messages/GenerateMessages';

import scss from './GenieGo.module.scss';

function GenieGo() {
  const dispatch = useDispatch();

  const handlePredictResponse = (values) => {
    dispatch(predictConsumerGenieGoResponse(values));
  };

  return (
    <ConsumerLayout Header={Header()}>
      <div className={scss.pageWrapper}>
        <PredictResponse onPredictResponse={handlePredictResponse} />

        <GenerateMessages
          onGenerateMessages={generateConsumerGenieGoMessages}
          onReply={replyConsumerGenieGo}
          onResetSession={resetGenieGoSession}
          onFileUpload={uploadFile}
        />
      </div>
    </ConsumerLayout>
  );
}

export default GenieGo;
